// ----------------------------------------------------------------------
// <copyright file="Izenda.NumericInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Numeric Input component
 */

import SimpleNumber from 'react-widgets/lib/localizers/simple-number';
import React, { Component, PropTypes } from 'react';
import { NumberPicker as RWNumberPicker } from 'react-widgets';
import classnames from 'classnames';
import { omit, assign, replace } from 'lodash/fp';
SimpleNumber();

import { Number as UiNumber } from 'logic/data/Izenda.UIConstants';

class NumericInput extends Component {
  static propTypes = {
    isHideSpinner: PropTypes.bool,
    showInfoIcon: PropTypes.bool,
    hint: PropTypes.string,
    onChange: PropTypes.func,
    isDecimal: PropTypes.bool,
    max: PropTypes.number,
    min: PropTypes.number
  };

  static defaultProps = {
    isHideSpinner: true,
    showInfoIcon: false,
    hint: '',
    isDecimal: true,
    max: UiNumber.MAX,
    min: UiNumber.MIN
  };

  render() {
    const props = this.props;
    const { isHideSpinner, showInfoIcon, isDecimal, hint, max, min } = props;

    const classes = classnames({
      'numeric-input': true,
      'hide-spinner': isHideSpinner,
      'show-icon': showInfoIcon
    });
    let omitProps = omit(
      ['hint', 'showInfoIcon', 'isDecimal', 'isHideSpinner', 'containerClassName', 'onChange', 'groupByDateTime'],
      props
    );
    omitProps.value === '' && (omitProps.value = null);
    isDecimal && (omitProps = assign(omitProps, { format: UiNumber.DECIMAL_FORMAT }));

    const changeInput = value => {
      if (!isDecimal && value) {
        const integerString = replace('.', '', value.toString());
        value = parseInt(integerString);
      }

      props.onChange && props.onChange(value);
    };

    return (
      <div className={classes}>
        <RWNumberPicker max={max} min={min} onChange={changeInput} {...omitProps} />
        {showInfoIcon ? (
          <a>
            <span className="icon-info-circled" title={hint} />
          </a>
        ) : null}
      </div>
    );
  }
}

export default NumericInput;



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.NumericInput.js